export const BRAND = {
  zhName: '灵犀工坊',
  enName: 'LINGXI',
  enDescriptor: 'WORKSHOP',
  slogan: '心有灵犀，所想即成。',
  sloganEn: 'Make what matters, together.',
  productDescription: '与你的 AI，一起把想法做成工具。',
  productDescriptionEn: 'Build useful tools with your AI.',
} as const;
